var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MhRouterView',{staticClass:"EditView view maxWidth maxWidth--appBody",attrs:{"isContentReady":_vm.isContentReady}},[_c('div',{staticClass:"EditView__inner view__inner"},[_c('KnEditForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }